import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import BannerCreate from "../../pages/Home/Banner/BannerCreate/BannerCreate";
import BannerEdit from "../../pages/Home/Banner/BannerEdit/BannerEdit";

import SolutionPage from "../../pages/Home/Solution/Solution";
import SolutionEdit from "../../pages/Home/Solution/SolutionEdit/SolutionEdit";

import WhyChoose from "../../pages/Home/WhyChoose/WhyChoose";
import PolicyPage from "../../pages/Home/Policy";
import OtherPage from "../../pages/Home/Other/Other";

import ProductPage from "../../pages/Product/Product";
import ProductDetail from "../../pages/Product/Detail/ProductDetail";
import OtherEditPage from "../../pages/Home/Other/SolutionEdit/OtherEdit";
import BannerCategory from "../../pages/Category/Banner/BannerCategory";
import BannerCategoryEdit from "../../pages/Category/Banner/BannerEdit/BannerCategoryEdit";
import BannerCategoryCreate from "../../pages/Category/Banner/BannerCreate/BannerCategoryCreate";
import BannerProduct from "../../pages/Product/Banner/BannerProduct";
import BannerProductCreate from "../../pages/Product/Banner/BannerCreate/BannerProductCreate";
import BannerProductEdit from "../../pages/Product/Banner/BannerEdit/BannerProductEdit";
import ContactPage from "../../pages/Contact/ContactPage";
import ContactEditPage from "../../pages/Contact/ContactEdit/ContactEdit";
import BannerHomePage from "../../pages/Home/Banner/Banner";
import ListCategory from "../../pages/Category/List/ListCategory";
import DataCategoryEdit from "../../pages/Category/List/DataEdit/CategoryEdit";
import ProductCreate from "../../pages/Product/ProductCreate/ProductCreate";
import StandingPage from "../../pages/Home/Standing";
import OriginPage from "../../pages/Home/Origin/OriginPage";
import TodayCategory from "../../pages/Category/Today";
import BestSaleCategory from "../../pages/Category/BestSale";
import DiscoverCategory from "../../pages/Category/Discover";
import TopTrendCategory from "../../pages/Category/TopTrend";
import PolicyCategory from "../../pages/Category/Policy";
import ProductUpdate from "../../pages/Product/ProductUpdate/ProductUpdate";
import CollectionHome from "../../pages/Home/Collection/Collection";
import CollectionCreate from "../../pages/Home/Collection/BannerCreate/BannerCategoryCreate";
import DataCreate from "../../pages/Category/List/DataCreate/DataCreate";

const ContentComponent = () => {
  return (
    <Routes>
      {/* Home / Banner */}
      <Route path="/Home/Title" element={<BannerHomePage />} />
      <Route path="/Home/Banner/Create" element={<BannerCreate />} />
      <Route path="/Home/Banner/Edit" element={<BannerEdit />} />

      {/* Home / Solution */}
      <Route path="/Home/Solution" element={<SolutionPage />} />
      <Route path="/Home/Solution/Create" element={<SolutionEdit />} />
      <Route path="/Home/Solution/Edit" element={<SolutionEdit />} />

      <Route path="/Home/WhyChoose" element={<WhyChoose />} />
      <Route path="/Home/Policy" element={<PolicyPage />} />
      <Route path="/Home/Standing" element={<StandingPage />} />
      <Route path="/Home/Origin" element={<OriginPage />} />


      <Route path="/Home/Other" element={<OtherPage />} />
      <Route path="/Home/Collection" element={<CollectionHome />} />
      <Route path="/Home/Collection/Create" element={<CollectionCreate />} />


      <Route path="//Home/Other/:id" element={<OtherEditPage />} />
      <Route path="/Product/Banner" element={<BannerProduct />} />
      <Route path="/Product/Banner/Create" element={<BannerProductCreate />} />
      <Route path="/Product/Banner/:id" element={<BannerProductEdit />} />
      <Route path="/Product/Data" element={<ProductPage />} />
      <Route path="/Product/Data/Create" element={<ProductCreate />} />
      <Route path="/Product/Data/Update/:id" element={<ProductUpdate />} />


      <Route path="/Product/:id" element={<ProductDetail />} />

      <Route path="/Category/Banner" element={<BannerCategory />} />
      <Route path="/Category/Banner/Create" element={<BannerCategoryCreate />} />
      <Route path="/Category/Banner/:id" element={<BannerCategoryEdit />} />
      <Route path="/Category/Data" element={<ListCategory />} />
      <Route path="/Category/Data/Create" element={<DataCreate />} />

      <Route path="/Category/Data/:id" element={<DataCategoryEdit />} />
      <Route path="/Category/Today" element={<TodayCategory />} />
      <Route path="/Category/BestSale" element={<BestSaleCategory />} />
      <Route path="/Category/Discover" element={<DiscoverCategory />} />
      <Route path="/Category/TopTrend" element={<TopTrendCategory />} />
      <Route path="/Category/Policy" element={<PolicyCategory />} />





      <Route path="/Contact" element={<ContactPage />} />
      <Route path="/Contact/Edit" element={<ContactEditPage />} />

      <Route path="/" element={<Navigate to="/Product" />} />
      <Route path="*" element={<div>Trang không tồn tại</div>} />
    </Routes>
  );
};

export default ContentComponent;
